<template>
  <v-tabs v-model="tabs">
    <v-tab :key="1">{{ labels.general }}</v-tab>
    <v-tab-item :key="1">
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.details }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.insdRefNoAe }}</v-subheader>
                <div class="queryValue">{{ formatBoolean(insuredForm.insdRefNoAe) }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.clientGrp }}</v-subheader>
                <div class="queryValue">{{ formatClientGrp(insuredForm.clientGrp) }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.clientType }}</v-subheader>
                <div class="queryValue">{{ insuredForm.clientType }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.titleName }}</v-subheader>
                <div class="queryValue">{{ insuredForm.titleName }}</div>
              </v-flex>
              <v-flex md8 xs12>
                <v-subheader class="queryLabel">{{ labels.fullName }}</v-subheader>
                <div class="queryValue">{{ insuredForm.fullName }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.postalCode }}</v-subheader>
                <div class="queryValue">{{ insuredForm.postalCode }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.address1 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.address1 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.address2 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.address2 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.address3 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.address3 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.address4 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.address4 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.abbrevName }}</v-subheader>
                <div class="queryValue">{{ insuredForm.abbrevName }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.contact }}</v-subheader>
                <div class="queryValue">{{ insuredForm.contact }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.telNo1 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.telNo1 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.telNo2 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.telNo2 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.telNo3 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.telNo3 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.telNo4 }}</v-subheader>
                <div class="queryValue">{{ insuredForm.telNo4 }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.email }}</v-subheader>
                <div class="queryValue">{{ insuredForm.email }}</div>
              </v-flex>
              <v-flex md8 xs12>
                <v-subheader class="queryLabel">{{ labels.web }}</v-subheader>
                <div class="queryValue">{{ insuredForm.web }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ insuredForm.strCreatedBy }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(insuredForm.createdDate) }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.createdProgId }}</v-subheader>
                <div class="queryValue">{{ insuredForm.createdProgId }}</div>
              </v-flex>
              <v-flex md4 xs12>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ insuredForm.strModifiedBy }}</div>
              </v-flex>
              <v-flex md8 xs12>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(insuredForm.modifiedDate) }}</div>
              </v-flex>
              <v-flex xs12>
                <v-expansion-panels v-model="toogleArray" multiple>
                  <v-expansion-panel :disabled="boolClientGrpI">
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Individual</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                              <div class="queryValue">{{ formatGender(insuredForm.gender) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.dob }}</v-subheader>
                              <div class="queryValue">{{ formatDate(insuredForm.dob) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.icNo }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.icNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel :disabled="boolClientGrpC">
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Corporation</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.coRegNo }}</v-subheader>
                              <v-subheader class="queryLabel">{{ labels.coRegDate }}</v-subheader>
                            </v-flex>
                            <v-flex md4 xs12>
                              <div class="queryValue">{{ insuredForm.coRegNo }}</div>
                              <div class="queryValue">{{ formatDate(insuredForm.coRegDate) }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Other details and settings</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.gstRegDate }}</v-subheader>
                              <div class="queryValue">{{ formatDate(insuredForm.gstRegDate) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.inactive }}</v-subheader>
                              <div class="queryValue">{{ formatBoolean(insuredForm.inactive) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.blackList }}</v-subheader>
                              <div class="queryValue">{{ formatBoolean(insuredForm.blackList) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.chgNAPol }}</v-subheader>
                              <div class="queryValue">{{ formatBoolean(insuredForm.chgNAPol) }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.insdBillAcct }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.insdBillAcct }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.grpRefStmt }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.grpRefStmt }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.grpRefAge }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.grpRefAge }}</div>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-subheader class="queryLabel">{{ labels.grpRefStats }}</v-subheader>
                              <div class="queryValue">{{ insuredForm.grpRefStats }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      tabs: 0,
      toogleArray: [0],
      labels: {
        general: 'General',
        details: 'Details',
        insdRefNoAe: 'Auto generate Insured Reference',
        insdRefNo: 'Insured Reference*',
        clientGrp: 'Client Group',
        clientType: 'Client Type',
        titleName: 'Title',
        fullName: 'Full Name',
        postalCode: 'Postal Code',
        address1: 'Address 1',
        address2: 'Address 2',
        address3: 'Address 3',
        address4: 'Address 4',
        address5: 'State',
        address6: 'Country',
        abbrevName: 'Abbreviated Name',
        contact: 'Contact Name',
        telNo1: 'Home No.',
        telNo2: 'Office No.',
        telNo3: 'Mobile No.',
        telNo4: 'Fax No.',
        email: 'Email',
        web: 'Web page',
        gender: 'Gender',
        dob: 'Birthday',
        icNo: 'NRIC',
        coRegNo: 'Company Registration No.',
        coRegDate: 'Registration Date',
        gstRegNo: 'GST Registration No.',
        gstRegDate: 'GST Registration Date',
        inactive: 'Insured is Inactive',
        blackList: 'Insured is Blacklisted',
        chgNAPol: 'Allow Change in Policy',
        insdBillAcct: 'Default Billing Account No.',
        grpRefStmt: 'Group Statement Insured Reference',
        grpRefAge: 'Group Ageing Insured No.',
        grpRefStats: 'Group Statistics Insured Reference',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        createdProgId: 'Created Program ID',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      insuredForm: {
        insdRefNoAe: false,
        insdRefNo: undefined,
        clientGrp: 'I',
        clientType: undefined,
        titleName: undefined,
        fullName: undefined,
        postalCode: undefined,
        address1: undefined,
        address2: undefined,
        address3: undefined,
        address4: undefined,
        abbrevName: undefined,
        contact: undefined,
        telNo1: undefined,
        telNo2: undefined,
        telNo3: undefined,
        telNo4: undefined,
        email: undefined,
        web: undefined,
        gender: 'N',
        dob: undefined,
        icNo: undefined,
        coRegNo: undefined,
        coRegDate: undefined,
        gstRegNo: undefined,
        gstRegDate: undefined,
        inactive: false,
        blackList: false,
        chgNAPol: false,
        insdBillAcct: undefined,
        grpRefStmt: undefined,
        grpRefAge: undefined,
        grpRefStats: undefined,
        createdBy: undefined,
        createdDate: undefined,
        createdProgId: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      boolClientGrpI: false,
      boolClientGrpC: false,
      menu: []
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  methods: {
    doReview() {
      this.$router.push({ name: 'reviewDetails', params: { insdRefNo: this.insuredForm.insdRefNo, clientType: this.insuredForm.clientType } })
    },
    queryLimit() {
      this.$toast.warning('Cannot do this in query mode')
    },
    doBack() {
      this.$router.push({ name: 'insureds' })
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    formatClientGrp(clientGrp) {
      if (clientGrp === 'I') {
        return 'Individual'
      } else if (clientGrp === 'C') {
        return 'Corporation'
      }
    },
    formatGender(gender) {
      if (gender === 'F') {
        return 'Female'
      } else if (gender === 'M') {
        return 'Male'
      } else {
        return 'Not Applicable'
      }
    }
  },
  created() {
    this.insuredForm = this.$store.state.adminInsured.insured
    if (this.insuredForm.clientGrp === 'I') {
      this.boolClientGrpI = false
      this.boolClientGrpC = true
    } else if (this.insuredForm.clientGrp === 'C') {
      this.boolClientGrpI = true
      this.boolClientGrpC = false
    } else {
      this.boolClientGrpI = false
      this.boolClientGrpC = false
    }
  },
  props: ['insdRefNo', 'clientType']
}
</script>

<style lang="scss">
</style>
